<script setup lang="ts">
import BattleSimulatorAttackingFleet from './BattleSimulatorAttackingFleet.vue'
import BattleSimulatorDefendingFleet from './BattleSimulatorDefendingFleet.vue'
import BattleSimulatorDefendingPlanet from './BattleSimulatorDefendingPlanet.vue'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import { useBattleSimulatorStore } from '@/stores/battleSimulatorStore'
import { useGameStore } from '@/stores/gameStore'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const battleSimulatorStore = useBattleSimulatorStore()
const gameStore = useGameStore()

const startBattle = () => {
  battleSimulatorStore.runBattle()
  gameStore.modalType = 'battleSimulatorResult'
}

const clearAll = () => {
  battleSimulatorStore.clearAttackingFleet()
  battleSimulatorStore.clearDefendingFleet()
  battleSimulatorStore.resetPlanetDefense()
}
</script>

<template>
  <div class="bg-slate-900 content-height-limit-tab overflow-y-auto">
    <div class="flex flex-col xl:flex-row p-2 gap-2 mx-auto">
      <div class="w-full xl:w-1/2">
        <BattleSimulatorAttackingFleet />
      </div>
      <div class="w-full xl:w-1/2 pt-4 xl:pt-0">
        <BattleSimulatorDefendingFleet />
        <BattleSimulatorDefendingPlanet />
      </div>
    </div>
    <div class="flex justify-center gap-4 p-4">
      <ActionButton @click="startBattle">{{ t('command.battleSimulator.simulateBattle') }}</ActionButton>
      <ActionButton @click="clearAll">{{ t('common.actions.clear') }}</ActionButton>
    </div>
  </div>
</template>

<style scoped>

</style>